import { VerticalState } from './VerticalTypes';

export const VerticalAction = {
   FETCH_VERTICAL: 'FETCH_VERTICAL',
};

export const VerticalURL = {
   REVIEW: '/api/Vertical/Get',
};

export const DEFAULT_STATE: VerticalState = {
   verticals: []
};
